import * as Yup from 'yup';
import { PACKAGING_TYPE_OPTIONS } from '../../../utils/constants/packagingTypes';
import { PACKAGING_CHARACTER_OPTIONS } from '../../../utils/constants/packagingCharacters';
import { EU_COUNTRY_CODES } from '../../../utils/constants/euCountries';
import { BASE_ROLE_OPTIONS, PRODUCER_ROLE_OPTIONS } from '../../../utils/constants/packagingRoles';

const BASE_ROLE_VALUES = BASE_ROLE_OPTIONS.map(o => o.value);
const PRODUCER_ROLE_VALUES = [...PRODUCER_ROLE_OPTIONS.map(o => o.value), 'NOT_APPLICABLE'];

export const formValues = {
    name: '',
    code: '',
    gtin: '',
    packagingType: '',
    character: '',
    foodContact: false,
    recyclable: false,
    deposit: false,
    usage: '',
    digitalPassportUrl: '',
    description: '',
    operationDescription: '',
    internalNote: '',
    translations: {},
    marketCountries: [],
    marketDate: '',
    baseRole: '',
    producerRole: 'NOT_APPLICABLE',
};

const commonFields = {
    name: Yup.string().min(2, 'Minimálne 2 znaky').max(200, 'Maximálne 200 znakov').required('Názov je povinný'),
    code: Yup.string().max(100, 'Maximálne 100 znakov'),
    gtin: Yup.string().max(14, 'GTIN má maximálne 14 znakov').matches(/^\d*$/, 'GTIN môže obsahovať len číslice'),
    packagingType: Yup.string().oneOf(PACKAGING_TYPE_OPTIONS.map(o => o.value)).required('Typ obalu je povinný'),
    character: Yup.string().oneOf(PACKAGING_CHARACTER_OPTIONS.map(o => o.value)).required('Charakter obalu je povinný'),
    foodContact: Yup.boolean(),
    recyclable: Yup.boolean(),
    deposit: Yup.boolean(),
    usage: Yup.string().max(500, 'Maximálne 500 znakov'),
    digitalPassportUrl: Yup.string().url('Zadajte platnú URL adresu').max(2000, 'Maximálne 2000 znakov'),
    description: Yup.string().max(1000, 'Maximálne 1000 znakov'),
    operationDescription: Yup.string().max(1000, 'Maximálne 1000 znakov'),
    internalNote: Yup.string().max(1000, 'Maximálne 1000 znakov'),
    marketCountries: Yup.array().of(Yup.string().oneOf(EU_COUNTRY_CODES)).min(1, 'Vyberte aspoň jeden trh uvedenia').required('Trh uvedenia je povinný'),
    marketDate: Yup.date().typeError('Zadajte platný dátum').nullable(),
};

export const validation = Yup.object({
    ...commonFields,
    baseRole: Yup.string().oneOf(BASE_ROLE_VALUES).required('Základné postavenie je povinné'),
    producerRole: Yup.string().oneOf(PRODUCER_ROLE_VALUES).required('Postavenie výrobcu je povinné'),
});

export const editValidation = Yup.object(commonFields);
